export const STORAGE_KEY_REDUX_ACTIONS = 'performance-redux-actions'
export const STORAGE_KEY_REALTIME_REDUX_ACTIONS =
  'performance-realtime-redux-actions'
export const STORAGE_KEY_CAN_LOG_REDUX_ACTIONS = 'performance-can-log-actions'
